/* eslint-env browser */

module.exports = ImageData
